export default "__VITE_ASSET__ChboIjTy__"